// @flow

import React from 'react';
import { AppBar as MuiAppBar, Toolbar, Typography } from '@material-ui/core/';
import AppLogo from '../applogo';
//import { QuickSearchButton } from '../search/quick-search';
import AppMenu from '../appmenu';
import SignInButton from '../signin/button';
import Mobile from '../mobile';
// import LangPicker from '../localization/lang-picker';
import ActiveUserMenu from'../ActiveUserMenu/MenuList';
import Routes from '../../routes';
import ActiveRoute from '../../routes/active-route';
import { UserContext } from '../../app';

import './style.css';
import '../../components/headerbar/style.css';

function HeaderBar() {
    const { currentUser } = React.useContext(UserContext);
    const activeRoute = ActiveRoute();
    console.log(activeRoute);

    return (
        <MuiAppBar
            position="sticky"
            className={`app-bar logo-bg 
                banner-height
            `}
        >
            <Typography component="div">
                <Toolbar>
                    <AppLogo />
                    {/*  <QuickSearchButton /> */}
                    <AppMenu ActiveMenu={activeRoute} />
                    {/* <LangPicker className="lang-picker" /> */}
                    {currentUser ? <ActiveUserMenu /> : <SignInButton />}
                    <Mobile ActiveMenu={activeRoute} />
                </Toolbar>
            </Typography>
            <Typography component="h1" className="first-body">
            
                </Typography>
                <Typography>
                <div class="announcement-banner">
                    <div>We’re excited to announce that version 7 (V7) of our Sureprep APIs are now available, featuring a standardized authentication method with Thomson Reuters accounts.    
            <div class="h2txt">   Visit the <a class="pln-anchr" href='https://developers.thomsonreuters.com/pages/api-catalog?tab=messages&numberOfResults=10'>Thomson Reuters Developer Experience  </a>to learn more about V7 APIs (going forward, any new development documentation, including V5 content, will be hosted here).</div>
        </div>
        <a href="https://helpcenter.sureprep.com/hc/en-us/articles/27581291200407">Learn More</a>
    </div>
                </Typography>
        </MuiAppBar>
    );
}

export default HeaderBar;

// // Dev Portal
